module.exports = __webpack_public_path__ + "img/ks.656968eb.webp";